import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import FileUploader from "../../../citizen/AVPForms/reusableComponents/FileUploader2";
import ButtonWrapper from "../../../citizen/AVPForms/components/Button";
import { useSelector } from "react-redux";
import { BackButton, Toast } from "@egovernments/digit-ui-react-components";
import { IconButton, Tooltip } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { FaFileExcel } from "react-icons/fa";
import { getDocumentByFileStoreId } from "@egovernments/digit-ui-libraries/src/utils/fileType";
const CreateNOC = () => {
  const [showError, setShowError] = useState(false);
  const [showToast, setShowToast] = useState(null);
  const [isPreviewLoadingLoading, setIsPreviewLoading] = useState(false);
  const tenantId = Digit.ULBService.getStateId() || "up";
  const { documents } = useSelector((state) => state.formMT);
  const { handleSubmit, control, setValue } = useForm({});
  const validateFiles = () => {
    const uploadedDocs = new Set(documents?.map((doc) => doc.documentType)); // Using Set for faster lookups
    const requiredDocs = ["nocExcel"];

    return requiredDocs.every((doc) => uploadedDocs.has(doc)); // Use Set.has for O(1) lookup
  };
  const tooltipMessage = "Excel template available for download!";
  const closeToast = () => {
    setShowToast(null);
  };
  const handleFormSubmit = (data) => {
    const isValid = validateFiles();
    console.log("insideFormSUbmit", data, isValid);
    if (isValid) {
      console.log("submitIf", isValid, data);
      onSubmit(data);
    } else {
      setShowError(true);
      console.log("submitElse", isValid, showError);
      return;
    }
  };
  useEffect(() => {
    setValue("documents", documents);
  }, [documents]);
  const onSubmit = async (data) => {
    console.log("dataFromCreateNOC", data);
    const fileStoreId = data?.documents?.[0]?.fileStoreId;
    const nocRequest = { fileStoreId, tenantId };

    try {
      const result = await Digit.OBPSService.NOCExcelCreate(tenantId, { nocRequest });
      console.log("loggingResultNOC", result);
      setShowToast({ key: "success", message: result?.message });
    } catch (e) {
      setShowToast({ key: "true", error: true, message: e?.response?.data?.Errors[0]?.message });
    }
  };
  return (
    <React.Fragment>
      <BackButton />
      <section className="groupContainer3">
        <form onSubmit={handleSubmit(handleFormSubmit)}>
          <div className="formContainer">
            <div className="formHeaderContainer">
              <h2 className="formHeading">{"NOC Master"}</h2>
            </div>
            <Container className="formInputContainer" fluid>
              <Row style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <Col>
                  <FileUploader
                    control={control}
                    name="nocExcel"
                    label="Attach Excel Sheet"
                    validationMsg="(.xlsx) are allowed. Max file size: 10 MB."
                    isMandatory
                    required
                    tab={6}
                    maxFiles={1}
                    showError={showError}
                  />
                </Col>
                <Col>
                  <div style={{ marginTop: "22px" }}>
                    <Tooltip
                      title={tooltipMessage}
                      onClick={() => getDocumentByFileStoreId("900fbc5f-39c6-4d0f-8c56-58c840fc2c67", setIsPreviewLoading)}
                      arrow
                    >
                      Excel Template
                      <IconButton size="small">
                        <FaFileExcel fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </div>
                </Col>
              </Row>
            </Container>
            <div className="footerContainer2">
              <div className="buttonWrapper">
                <ButtonWrapper
                  variant="contained"
                  color="success"
                  size="medium"
                  label={"Save"}
                  type="submit"
                  // disabled={loading}
                  sx={{ backgroundColor: "black", marginRight: "4px", marginTop: "20px" }}
                />
              </div>
            </div>
          </div>
        </form>
        {showToast && (
          <Toast error={showToast?.error} warning={showToast?.warning} label={showToast?.message} onClose={closeToast} isDeleteBtn={true} />
        )}
      </section>
    </React.Fragment>
  );
};

export default CreateNOC;
